import {FC} from "react";
import {UnityIncidentTabContent} from "./content";
import {Unity} from "../../../../domain/unity";
import {useOutletContext} from "react-router-dom";

export const UnityIncident: FC = () => {
    const unity = useOutletContext() as Unity;
    return <UnityIncidentTabContent unity={unity}/>;
};
